import { getMaxWidth } from '../utils/layout';

/**
 * Directive to apply layout styles to block elements
 */
export function layoutStyles(
  node: HTMLElement,
  block?: { layout?: { width?: number | 'full' } }
) {
  function applyStyles() {
    if (!block?.layout?.width) return;

    const maxWidth = getMaxWidth(block.layout);
    node.style.maxWidth = maxWidth;
  }

  applyStyles();

  return {
    update(newBlock?: { layout?: { width?: number | 'full' } }) {
      block = newBlock;
      applyStyles();
    },
  };
}
